import Controls from "../components/Controls";
import RoomPage from "../components/RoomPage";

export default function EstatePage() {
  return <RoomPage roomId="estate" slug="petkiek" className="estate-page" heroClassName="estate-room-hero" headingClassName="estate-heading" navigation={<Controls backTo="/szalon" nextTo="/petkiek/konyv" />} />;
}
